import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for Capacitor mobile app
 * Helps determine whether app is running on web or native mobile
 */

/**
 * Check if app is running on a native mobile platform (iOS or Android)
 * @returns {boolean} True if running on native mobile
 */
export const isNativeMobile = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if app is running on web/browser
 * @returns {boolean} True if running on web
 */
export const isWeb = () => {
  return !Capacitor.isNativePlatform();
};

/**
 * Get the current platform name
 * @returns {string} 'ios', 'android', or 'web'
 */
export const getPlatform = () => {
  return Capacitor.getPlatform();
};

/**
 * Check if app is running on Android
 * @returns {boolean} True if running on Android
 */
export const isAndroid = () => {
  return Capacitor.getPlatform() === 'android';
};

/**
 * Check if app is running on iOS
 * @returns {boolean} True if running on iOS
 */
export const isIOS = () => {
  return Capacitor.getPlatform() === 'ios';
};
